import { IssueData, ZodIssueCode } from 'zod';
import { isString } from 'utils/tsHelpers';
import { validateDate as hasDateError } from 'utils/validateDate';
import { isEmptyString } from 'utils/stringHelpers';
import { CastType } from '../../../types';

export const validateEpochCastTypeValue = (
  {
    value,
    castType,
  }: Partial<{
    value: string;
    castType: CastType;
  }>,
  addIssue: (arg: IssueData) => void,
) => {
  if (castType !== CastType.EPOCHS_MILLIS && castType !== CastType.EPOCHS_SECS) return;
  const isStringValue = isString(value);
  const isNonEmptyString = !isEmptyString(value);
  const dateErrorExists = isStringValue && hasDateError(value);

  const hasEpochCastTypeNumberValueError = isStringValue && isNonEmptyString && dateErrorExists;

  /** when castType is Epoch Mills or Epoch Secs we want to validate the value as a date value rather than a number value */
  if (hasEpochCastTypeNumberValueError) {
    addIssue({
      code: ZodIssueCode.custom,
      message: 'invalid date for epoch value',
      path: ['value'],
    });
  }
};
